import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createBuyerSellerDumpReportApi(params: any) {
  let apiData: any = {
    programExternalId: params.programmeId.length ? params.programmeId : null,
    saveReport: params.saveReport
  };
  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/buyer-seller-dump-report`;
  return api.create(`${backendApiUrl}`, apiData);
}

export { createBuyerSellerDumpReportApi };